import request from '@/common/js/request'
/***
 * 获取组织树数据
 */
export const getDeptList = (params) => {
    return request('/baseDept/list', {
        params: params,
        method: 'get'
    })
}

/***
 * 查询当前用户组织树
 */
 export const currentUserDeptTree = (params) => {
    return request('/baseDept/currentUserDeptTree', {
        params: params,
        method: 'get'
    })
}

/***
 * 告警列表 催告中及悲催高获取组织树数据
 */
 export const getReminderDeptList = (params) => {
    return request('/baseDept/deptTree', {
        params: params,
        method: 'get'
    })
}

/***
 * 查询组织树
 */
export const deptTree = (params) => {
    return request('/baseDept/deptTree', {
        params: params,
        method: 'get'
    })
}

/***
 * 根据组织获取组织下的人员
 */
export const getDeptPearson = (params) => {
    return request('/baseUser/list', {
        params: params,
        method: 'get'
    })
}
